//shared containers
import { Footer } from '@/containers-m/Footer';
import { Navigation } from '/containers-m/';

//containers
import {
  Hero,
  WatchItRunYourFreight,
  HowItWorks,
  RunsOnYourStack,
  TheRestOfTheLineup,
  EndCTA,
} from '../containers';

//styles
import {
  PageWrapper,
  TrackingAndStatusUpdatesGlobalStyle,
} from './TrackingAndStatusUpdates.styles';

const hero = {
  slug: 'tracking-and-status-updates',
  title: 'Tracking & Status Updates',
  description:
    'Pulls carrier status on a schedule, chases the carriers that go quiet, escalates the ones that stay quiet, and pushes clean updates to your team and your customers. No check calls.',
  metric: '5–10 min',
  metricLabel: 'saved per tracked load',
};

const watchItRun = {
  title: 'A load’s gone quiet',
  stageHeadTitle:
    'A customer’s asking where load #LS-51204 is — and it’s gone quiet.',
  stageHeadMeta: 'Tracking · #LS-51204',
  rows: [
    {
      time: '09:14:10',
      text: 'No tracking ping on #LS-51204 for 4 hours.',
    },
    {
      time: '09:14:12',
      text: 'Reached the carrier — truck’s rolling, 40 min behind.',
    },
    {
      time: '09:14:40',
      text: 'ETA recalculated and written back to your TMS.',
    },
    {
      time: '09:14:42',
      text: 'Still inside the delivery window — nothing needed from you.',
    },
    {
      time: '09:14:45',
      text: 'Clean status pushed to the customer before they asked again.',
    },
  ],
  summaryText:
    'A load stopped reporting and the customer was getting anxious. Loadsmart AI chased the carrier, confirmed the truck was moving, updated the ETA, and sent the customer a clean status — the check calls your team never had to make.',
  agentBadge: 'Tracking Agent',
  escalationTitle: 'When a carrier won’t answer, a person steps in.',
  escalationText:
    'Most carriers answer. The ones that stay dark after repeated requests get handed to a Loadsmart Freight Expert. Everything up to that point runs without anyone picking up a phone.',
};

const howItWorks = {
  stepsTitleWhite: 'Chases the update ',
  stepsTitleGradient: 'until it has one.',
  steps: [
    {
      title: 'Checks the window',
      description:
        'Confirms tracking has started on every pickup inside a set window.',
    },
    {
      title: 'Requests what’s missing',
      description:
        'Asks the carrier directly the moment tracking data doesn’t show up.',
    },
    {
      title: 'Escalates on repeat misses',
      description:
        'A carrier that keeps missing gets flagged and escalated, so the load doesn’t go dark unnoticed.',
    },
    {
      title: 'Clears the upstream blocker',
      description:
        'Chases missing driver, truck and contact detail from the carrier so tracking can start in the first place.',
    },
  ],
  outcomes: [
    {
      title: 'Exceptions surface early',
      description:
        'A missed check-in at hour four gets escalated at hour four, not when a customer calls three days later.',
    },
    {
      title: 'On-time performance and exception rate',
      description:
        'Both improve once tracking data flows on its own instead of on request.',
    },
    {
      title: 'The customer hears it from you first',
      description:
        'A delay reaches the person waiting on the load before they have to ask about it.',
    },
  ],
};

const lineupCards = [
  {
    slug: 'document-collection-and-filing',
    title: 'Document Collection & Filing',
    description:
      'We capture every quote, tender, rate con, BOL, POD and invoice as it arrives, and file it against the right shipment automatically.',
  },
  {
    slug: 'tender-failures',
    title: 'Tender Failures',
    description:
      'When a tender falls through, we re-tender down your routing guide and re-book, before the miss ever reaches your team.',
  },
  {
    slug: 'proactive-load-audits',
    title: 'Proactive Load Audits',
    description:
      'A load that goes untracked is also a load that can’t be audited before pickup.',
  },
  {
    slug: 'scheduling-and-re-scheduling',
    title: 'Scheduling & Re-Scheduling',
    description: 'Runs the same notification loop on the dock side.',
  },
  {
    slug: 'claims-processing',
    title: 'Claims Processing',
    description:
      'We gather the documentation, validate the claim, and draft the response for your approval, so claims get filed and recovered.',
  },
];

function TrackingAndStatusUpdates() {
  return (
    <PageWrapper>
      <TrackingAndStatusUpdatesGlobalStyle />
      <Navigation theme="dark" />
      <Hero {...hero} />
      <WatchItRunYourFreight {...watchItRun} />
      <HowItWorks {...howItWorks} />
      <RunsOnYourStack />
      <TheRestOfTheLineup cards={lineupCards} />
      <EndCTA agentName="Tracking & Status Updates" />
      <Footer />
    </PageWrapper>
  );
}

export default TrackingAndStatusUpdates;
export { TrackingAndStatusUpdates };
